import { Box, Typography } from '@mui/material';

function LogsTab({ logs }) {
    if (!logs) return (
        <Typography sx={{ fontSize: '12px', color: '#64748b', py: 2, textAlign: 'center' }}>
            Logs werden geladen…
        </Typography>
    );

    const levelColor = { ERROR: '#dc2626', WARN: '#d97706', INFO: '#3b82f6' };

    const renderSection = (label, text) => {
        if (!text || text.startsWith('Datei nicht')) return (
            <Box mb={2}>
                <Typography sx={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em', mb: 0.75 }}>{label}</Typography>
                <Typography sx={{ fontSize: '12px', color: '#475569' }}>Nicht verfügbar.</Typography>
            </Box>
        );
        const lines = text.split('\n').filter(Boolean).slice(-60);
        return (
            <Box mb={2}>
                <Typography sx={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em', mb: 0.75 }}>{label}</Typography>
                <Box sx={{ maxHeight: 220, overflowY: 'auto' }}>
                    {lines.map((l, i) => {
                        const s = String(l);
                        const lvl = s.match(/\b(ERROR|WARN|INFO)\b/i)?.[1]?.toUpperCase() || 'INFO';
                        return (
                            <Box key={i} display="flex" gap={1} sx={{ py: '3px', borderBottom: '0.5px solid rgba(255,255,255,.04)', '&:last-child': { border: 'none' } }}>
                                <Typography component="span" sx={{ fontSize: '10px', fontFamily: 'monospace', color: levelColor[lvl], fontWeight: 600, flexShrink: 0, width: 48 }}>
                                    [{lvl}]
                                </Typography>
                                <Typography component="span" sx={{ fontSize: '10px', fontFamily: 'monospace', color: '#64748b', wordBreak: 'break-all' }}>
                                    {s.replace(/\[(ERROR|WARN|INFO)\]/i, '').trim()}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        );
    };

    return (
        <Box>
            {renderSection('stdout', logs?.out)}
            {renderSection('stderr', logs?.error)}
        </Box>
    );
}

export default LogsTab;
